module.exports = __webpack_public_path__ + "static/media/528.ac5aa40a.jpg";